module.exports = __webpack_public_path__ + "static/where-are-the-customers-yachts-ee0a62cd1af11813b6518eb347f6a421.jpg";